(function ($) {
    $(function() {

        const $header = $('.js-header');

        /**
         * открытие подменю в бургер-меню
         */
        $header.on('click', '.js-show-submenu', function () {
            const $holder = $(this).closest('.js-list-item');
            const $dropdown = $holder.find('ul');
            const $items = $dropdown.find('li');
            const maxHeight = $items.first().outerHeight() * $items.length;
            let isOpened = $holder.hasClass('opened');

            if (isOpened) {
                $dropdown.css('max-height', '');
                $holder.removeClass('opened');
            } else {
                $dropdown.css('max-height', maxHeight + 'px');
                $holder.addClass('opened');
            }

        });

        /**
         * Показать/скрыть панель поиска
         */
        $header.on('click', '.js-show-search', function () {
            let $headerSearch = $(this).closest('.js-header')
                                .find('.js-header-search');
            let $input = $headerSearch.find('input');

            $(this).toggleClass('active');
            $headerSearch.toggleClass('active');

            if ($headerSearch.hasClass('active')) {
                $input.each(function (index, el) {
                    $(el).focus();
                })
            }
        });

        /**
         * Валидация строки поиска
         */
        $('.js-header-search').on('submit', 'form', function (e) {
            let $form = $(this);
            let $searchWrapper = $form.closest('.js-header-search');
            let $input = $searchWrapper.find('input');
            let $btn = $searchWrapper.find('button');

            if ($input.val().length < 3) {
                $btn.prop('disabled', true);
                return false;
            } else {
                $btn.prop('disabled', true);
                $btn.removeClass('active');
                $btn.addClass('loading');
            }
        }).on('input', 'input', function () {
            let $input = $(this);
            let $searchWrapper = $input.closest('.js-header-search');
            let $btn = $searchWrapper.find('button');

            if ($input.val().length >= 3) {
                $btn.prop('disabled', false);
                $btn.addClass('active');
            } else {
                $btn.prop('disabled', true);
                $btn.removeClass('active');
            }
        });


        /**
         * Открыть бургер-меню
         */
        $header.on('click', '.js-hamburger-btn', function () {
            const $burgerMenu = $('.js-burger-menu');
            $header.addClass('show-menu');
            $('html').addClass('fixed');
            $burgerMenu.css({
                top: function() {
                    if ($header.hasClass('fixed')) {
                        return '';
                    } else {
                        const headerTop = $header.get(0).getBoundingClientRect().top;
                        const headerHeight = $header.outerHeight();
                        const headerMenuHeight = 40;
                        return `${headerTop + headerHeight - headerMenuHeight}px`;
                    }
                }
            });
        });

        /**
         * Закрыть бургер-меню
         */
        $header.on('click', '.js-close-menu', function () {
            $header.removeClass('show-menu');
            $('html').removeClass('fixed');
        });

        $header.fixedHeader();

        /**
         * Помечаем активный пункт меню магазина
         */
        var $eShopLeftMenu = $('.js-eshop-left-menu');
        if ($eShopLeftMenu.length === 1 && $eShopLeftMenu.data('common-selected-url')) {
            $header.find('.js-top-submenu-item')
                .filter('[data-url="' + $eShopLeftMenu.data('common-selected-url') + '"]')
                .addClass('active');
        }

        /**
         * Очистка инпута в футере
         */
        const $footer = $('.js-footer');
        const $footerSubscribeInput = $footer.find('.js-subscribe-input');
        const $footerSubscribeClear = $footer.find('.js-clear');

        $footerSubscribeClear.on('click', function () {
            $footerSubscribeInput.val('');
        });

        $footerSubscribeInput.on('input', function () {
            $(this).val() !== ''
                ? $(this).closest('.js-form-group').addClass('active')
                : $(this).closest('.js-form-group').removeClass('active');
        });

        /**
         * Анимация графиков в статистике на детальной матча
         */
        $('.js-stat-section').each(function () {
            if (!$(this).hasClass('animated')) {
                $(this).animateStatistic();
            }
        });

        /**
         * Автоматическая подстройка высоты textarea
         */
        $(document).on('input', '.js-textarea-autosize', function () {
            let self = this;
            $(self)
                .css('height', '') // сбрасываем текущую высоту
                .css('height', self.scrollHeight); // устанавливаем новую высоту
        });

        /**
         * Функция вызова протокола с оверлеем
         */
        $('.js-detailed-content').each(function () {
            $(this).protocolControls();
        });

        /**
         * Управление переключением табами на детальной матча
         */
        $('.js-match-detailed-tabs').each(function () {
            $(this).matchDetailedTabs();
        });

        /**
         * Плагин рендера таймлайна матча
         */
        $('.js-match-timeline').each(function () {
            $(this).matchTimeline();
        });

        $('.js-match-lineups').each(function () {
            $(this).slidingTabs();
        });

        $(document)
            .on('click', '.js-popup-open', function () {
                let $self = $(this);
                $.magnificPopup.open({
                    items: {
                        src: $self.data('target'),
                        type: 'inline'
                    }
                });
            })
            .on('click', '.js-popup-close', function () {
                $.magnificPopup.close();
            });

        // Анимация списка членов тренерского штаба
        $('.js-staff').each(function () {
            const $self = $(this);
            const $items = $self.find('.js-staff-list-item');
            let firstVisibleIndex = $items.length - 1;

            // Индекс первого полностью видимого элемента
            $items.each(function(index, el) {
                let offsetTop = $(el).offset().top;
                if (offsetTop > window.pageYOffset) {
                    firstVisibleIndex = Math.min(firstVisibleIndex, index);
                }
            });

            // Активация элементов с задержкой в соответствии с текущей областью видимости
            $items.each(function(index, el) {
                setTimeout(function () {
                    $(el).addClass('active');
                }, 200 * Math.max(0, index - firstVisibleIndex));
            });
        });

        /**
         *  Слайдер в баннере на главной
         */
        let $mainBanner;
        if ($('.js-main-banner').length) {
            $mainBanner = $('.js-main-banner').mainBannerSlider();
        }

        /**
         * Анимация главной страницы
         */
        $('.js-main-animation').each(function () {
            $(this).mainPageAnimation($mainBanner);
        });

        /**
         * Табы в статистике игроков
         */
        $('.js-top-players').each(function () {
            $(this).topPlayersTabs();
        });

        /**
         * Обычный слайдер фотографий
         */
        $('.js-images-slider').each(function () {
            $(this).imagesSlider();
        });

        /**
         * Инцииализация селекта
         */
        $('.js-select2').each(function (index, value) {
            $(value).selectWrapper();
        });

        /**
         * Генерация галлереи для карточки товара
         */
        $('.js-eshop-product-gallery').each(function () {
            $(this).data('eshopProductGallery', $(this).eshopProductGallery());
        });


        $(document).on('click', '.js-show-hospital-spoiler', function () {
            $(this).closest('.js-hospital-row').toggleClass('opened');
        });

        $('.js-spoiler').each(function () {
            $(this).data('spoiler', $(this).spoiler());
        });

        /**
         * Открыть/закрыть глоссарий
         */
        $(document).on('click', '.js-show-glossary', function (e) {
            if (SVK.checkBreakpoint() !== 'desktop') {
                $(e.target).closest('.js-glossary').toggleClass('opened');
            }
        });

        /**
         * Позиционирования матча в календаре на мобилах
         */
        $('.js-matches-calendar').on('click', '.js-day', function () {
            if (window.innerWidth < SVK.breakpoint['tablet-min']) {
                $('.js-matches-calendar').find('.js-day').removeClass('active');
                $(this).addClass('active');
                $(this).find('.day').removeClass('active-mobile-birthday');
                var $content = $(this).find('.day__content');
                var $container = $(this).closest('.js-matches-calendar');
                var containerLeft = $container.get(0).getBoundingClientRect().left;
                var containerRight = $container.get(0).getBoundingClientRect().right;
                var contentLeft = $content.get(0).getBoundingClientRect().left;
                var contentRight = $content.get(0).getBoundingClientRect().right;
                var delta = 0;
                if (contentRight > containerRight) {
                    delta = contentRight - containerRight;
                    $content.css('transform', 'translateX(' + (-$content.width() / 2 - delta) + 'px)');
                }
                if (contentLeft < containerLeft) {
                    delta = containerLeft - contentLeft;
                    $content.css('transform', 'translateX(' + (-$content.width() / 2 + delta) + 'px)');
                }
            }
        });


        $(document).on('click', '.js-hide-btn', function (e) {
            e.stopPropagation();
            $(this).closest('.js-day').removeClass('active');
        });

        $('.js-tabs').each(function () {
            const $self = $(this);

            // Обновление галереи при переключении табов
            $self.on('tabchange', function (event, data) {
                let $tabContent = data.contentElement;
                if ($tabContent.find('.js-images-slider').length) {
                    let sliderData = $tabContent.find('.js-images-slider').data();
                    if (sliderData.hasOwnProperty('galleryTop')) {
                        sliderData.galleryTop.update();
                    }
                    if (sliderData.hasOwnProperty('galleryThumbs')) {
                        sliderData.galleryThumbs.update();
                        for (let i = 0; i < 6; i++) {
                            sliderData.galleryThumbs.lazy.loadInSlide(i);
                        }
                    }
                }
            });

            $self.data('tabs', $self.tabs());
        });

        /**
         * Простой дропдаун
         */
        $('.js-simple-dropdown').each(function () {
            $(this).simpleDropdown();
        });

        /**
         * Страница сравнение команд
         */
        $('.js-comparison-page').each(function () {
            $(this).teamsComparison();
        })

        /**
         * Позиционирование корзины покупок при скролле
         */
        $(document).on('scroll', function () {
            let $basketShop = $('.js-basket-shop');
            if ($basketShop.length) {
                if ($('.js-header').hasClass('fixed')) {
                    $basketShop.addClass('fixed');
                } else {
                    $basketShop.removeClass('fixed');
                }
            }
        });

        $(document).on('click', function (e) {
            const $target = $(e.target);
            let $timeLineItems = $('.js-timeline-item');

            if ($timeLineItems.length && SVK.checkBreakpoint() !== 'desktop') {
                $timeLineItems.removeClass('active');
                const $timeLineItem = $target.closest('.js-timeline-item');

                if ($timeLineItem.length) {
                    $timeLineItem.addClass('active');
                }

                $timeLineItems.filter(function (index, el) {
                    return !$(el).hasClass('active');
                }).find('.timeline-bubble').css('transform', '');
            }
        });

        $(document).on('click', '.js-show-more-lots', function () {
            const $target = $(this);

            $target.closest('#auctionList').data('load-more', true);

            $target.closest('.js-tab-content')
            .find('.js-lot-item').removeClass('hidden').removeClass('last-default-visible');
            $target.hide();
        });

        // отображение блоков с баннерами (если они загрузились)
        $('.js-banner').each(function () {
            var $banner = $(this);
            var bannerHtml = $banner.html().trim();

            if (!bannerHtml.length) {
                return;
            }

            $banner.removeClass('visually-hidden')

            var $bannerGroup = $banner.parent('.js-banner-group.visually-hidden');
            if (!$bannerGroup.length) {
                return;
            }

            $bannerGroup.removeClass('visually-hidden');
        });

        /**
         * Открытие/закрытие инфо баннера
         */

        $('.js-info-banner').each(function () {
            const $banner = $(this);
            const $button = $(this).find('.js-info-banner-button');
            const $wrapper = $(this).find('.js-info-banner-wrapper');
            const closedClass = 'closed';

            $button.on('click', function () {
                toggleClass();
            })

            $wrapper.on('click', function () {
                if ($banner.hasClass(closedClass)) {
                    toggleClass();
                }
            })

            const toggleClass = function () {
                $banner.toggleClass(closedClass);
            }

            const adjusBannerPosition = function () {
                if ($banner.length) {
                    let scrollRect = $banner.parent().get(0).getBoundingClientRect();
                    scrollRect = scrollRect.top + (window.innerHeight / 2);
                    let topMargin = window.innerHeight / 2;

                    $banner.toggleClass('fixed', scrollRect <= topMargin);
                }
            };

            $(window).on('scroll resize load', adjusBannerPosition);


        });


        $(document).on('click', '.js-order-toggle', function (event) {
            const $order = $(event.target).closest('.js-order-list-item');
            if ($order.length) {
                $order.toggleClass('is-open');
            }
        });

        $('.js-profile-form').each(function(i, val) {
            $(val).profileFormEvents();
        });

        const $profileTicketsHolder = $('.js-profile-tickets');
        if ($profileTicketsHolder.length) {
            $profileTicketsHolder.profileTickets();
        }
    });
})(jQuery);


document.addEventListener('DOMContentLoaded', () => {
    initUploadPhotos();
});